import { render, staticRenderFns } from "./EquipoIndex.vue?vue&type=template&id=7b0bd4c7"
import script from "./EquipoIndex.vue?vue&type=script&lang=js"
export * from "./EquipoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports